import React from "react";
import {Redirect, useLocation} from "react-router-dom";
import {PAGE_URLS} from "constants/AppConstants.js";
import {useAppUser} from "contexts/AppUserContext";
import OnboardingPage from "pages/OnboardingPage";
import SignInPage from "pages/SignInPage";

/**
 * The web root. Signed-out visitors get the public landing page (Paddle approves a
 * checkout domain only from a page it can read without logging in). Any query or
 * hash still goes to the sign-in page: the Garmin, Suunto, Coros, Strava and
 * GPS-Speedsurfing OAuth redirects come back to the root with their code.
 */
function RootPage() {
  const {user, claims} = useAppUser();
  const {search, hash} = useLocation();

  if (search || hash) {
    return <SignInPage />;
  }
  if (user && claims) {
    return <Redirect to={PAGE_URLS.diaryPageUrl} />;
  }
  return <OnboardingPage />;
}

export default RootPage;
